import { Button } from 'components/Button/Button';
import { ButtonSize, ButtonVariant } from 'components/Button/Button.types';
import { ListingType } from 'types/ListingType';
import { showModal } from 'zustand-stores/modalStore';

type Props = {
  className?: string;
  disabled?: boolean;
  listingId: string;
  listingType: ListingType;
  listingUrl: Record<string, string>;
  noIcon?: boolean;
  onClick?: () => void;
  size?: ButtonSize;
  messageOverride?: string;
  variant?: ButtonVariant;
  tabIndex?: number;
};

export function ShareListingButton({
  className,
  listingId,
  listingType,
  listingUrl,
  onClick,
  messageOverride,
  disabled,
  noIcon,
  size,
  variant,
  tabIndex,
}: Props) {
  return (
    <Button
      type="button"
      className={className}
      icon={noIcon ? undefined : { type: 'normalized', name: 'share' }}
      aria-label="Share"
      data-qa-id="share-button"
      variant={variant || 'secondary'}
      disabled={disabled}
      tabIndex={tabIndex}
      size={size}
      onClick={(e) => {
        e.preventDefault();

        if (onClick) {
          onClick();
        }

        showModal('SHARE_LISTING', {
          listingId,
          listingType,
          listingUrl,
          messageOverride,
        });
      }}
    >
      {getText('Share')}
    </Button>
  );
}
